import { constants } from '../utils'
import base from './base'

const { headers, url, request } = base

const create = async (groupStudentId, degree, curriculum) => {
  const body = JSON.stringify({
    group_student_id: groupStudentId,
    degree_id: degree,
    curriculum_id: curriculum,
  })

  return request(url(constants.api.renewEnrollment.create), {
    method: 'POST',
    headers: headers(),
    body,
  })
}

const cancel = async groupStudentId =>
  request(url(constants.api.renewEnrollment.cancel(groupStudentId)), {
    method: 'POST',
    headers: headers(),
  })

const get = async (user, password) => {
  const body = JSON.stringify({
    user,
    password,
  })

  return request(
    url(constants.api.renewEnrollment.login),
    { method: 'POST', headers: headers(), body },
    { unauthorizedIsAnswer: true }
  )
}

const nextOffers = async groupStudentId =>
  request(url(constants.api.renewEnrollment.nextOffers(groupStudentId)), {
    method: 'GET',
    headers: headers(),
  })

const getPdf = async (groupStudentId, reenrollmentIntentHistoryId = false) =>
  request(url(constants.api.renewEnrollment.pdf(groupStudentId, reenrollmentIntentHistoryId)), {
    method: 'GET',
    headers: headers(true, { 'Content-Type': 'multipart/form-data', Accept: 'Application/pdf' }),
  })

const checkEligibility = async groupStudentId =>
  request(url(constants.api.renewEnrollment.checkEligibility(groupStudentId)), {
    method: 'GET',
    headers: headers(),
  })

const search = async cpf =>
  request(
    url(constants.api.renewEnrollment.search(cpf)),
    { method: 'GET', headers: headers() },
    { unauthorizedIsAnswer: true }
  )

const jobStatus = async (groupStudentId, jid = null, jobAction = 'create_renew_enrollment') =>
  request(url(constants.api.renewEnrollment.job_status(groupStudentId, jid, jobAction)), {
    method: 'GET',
    headers: headers(),
  })

const renewEnrollmentApi = {
  cancel,
  get,
  getPdf,
  nextOffers,
  create,
  checkEligibility,
  search,
  jobStatus,
}

export default renewEnrollmentApi
